export default Vue.extend({
  props: {
    title: {
      type: String,
      default: ''
    }
  },

  template: `
    <div class="main-content-wrapper">
      <div class="organization-head">
        <div class="organization-title">{{ title }}</div>
      </div>

      <div class="organization-wrap">
        <slot name="content"></slot>
      </div>
    </div>
  `
})
